import {SignalRHub} from "../hubs/signalr-hub";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {Endpoints} from "../../shared/config/constant.module";
import ChatMessage from "../../models/chat/chatMessage";
import {UserProfile} from "../../models/userProfile";
import * as angular from 'angular';
import * as _ from "lodash";
import HubServiceName, {HubService} from "../hubs/hub.service";
import HttpServiceName, {HttpService} from "../http/http.service";

let requires = [HubServiceName, HttpServiceName];

export interface ChatHub extends SignalRHub {
  joinGroup(shopId: string): Promise<any>;
  leaveGroup(shopId: string): Promise<any>;
}

export interface ChatService {
  sendMessage(command: apsCommands.AddChatMessage): angular.IPromise<any>;
  getMessages(plantId: string, shopId: string, startDate?: Date, endDate?: Date): angular.IPromise<ChatMessage[]>;
  createHub(shopId: string, onAdd: (event: apsViewModels.ChatAdded) => void): ChatHub;
}

class ChatSvc implements ChatService {
  private httpService: HttpService;
  private hubService: HubService;
  private userProfile: UserProfile;

  constructor(httpService: HttpService,
              userProfile: UserProfile,
              hubService: HubService) {
    this.httpService = httpService;
    this.userProfile = userProfile;
    this.hubService = hubService;
  }

  sendMessage(command: apsCommands.AddChatMessage): angular.IPromise<any> {
    return this.httpService.post(Endpoints.CHAT, command);
  }

  getMessages(plantId: string, shopId: string, startDate?: Date, endDate?: Date): angular.IPromise<ChatMessage[]> {
    return this.userProfile.read().then(userData => {
      return this.httpService.get(Endpoints.CHAT, {
        plantId: plantId,
        shopId: shopId,
        startDate: startDate,
        endDate: endDate
      }).then((data: apsViewModels.ChatItemBase[]) => {
        return _.map(data, item => new ChatMessage(item, userData));
      });
    });
  }

  createHub(shopId: string,
            onAdd: (event: apsViewModels.ChatAdded) => void): ChatHub {
    return this.hubService.createHub<ChatHub>('chat', {
      allowMultipleListeners: true,
      listeners: {
        chatMessageAdded: (chatAdded: apsViewModels.ChatAdded) => {
          if (onAdd && chatAdded.shopId === shopId) {
            onAdd(chatAdded);
          }
        }
      },
      methods: ['leaveGroup', 'joinGroup'],
      postConnect: (hub: ChatHub) => {
        hub.invokeWithRetry(() => hub.joinGroup(shopId));
      }
    });
  }
}

export default angular.module('aps.services.chat', requires)
  .service('chatService', ChatSvc)
  .name;



// WEBPACK FOOTER //
// ./src/app/services/chat/chat.service.ts